/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from 'react';
import { CopilotActualIcon, InfoIcon } from '../../../../assets/icons';
import { CardHeader } from '../../../components/CardHeader/CardHeader';
import { LftTaskCard } from '../../../components/LftTaskCard/LftTaskCard';
import { ProgressBar } from '../../../components/ProgressBar/ProgressBar';
import { strings } from '../../../intl/Strings';
import { useStyles } from './LftCountdownCard.styles';
import { LftCountdownAction } from './shared';

export type LftCountdownCardProps = {
    daysLeft?: number;
    actions: LftCountdownAction[];
};

export const LftCountdownCard: React.FC<LftCountdownCardProps> = ({
    daysLeft = 7,
    actions
}) => {
    const styles = useStyles();
    const totalDays = 7;
    const progress = totalDays > 0 ? ((totalDays - daysLeft) / totalDays) : 0;
    const progressMessage = strings.getString('lftTrialCountdownDaysLeft').replace('{0}', daysLeft.toString());

    return (
        <div className={styles.card}>
            <CardHeader
                title={strings.getString('lftSidePaneTrialCountdownTitle')}
                description={strings.getString('lftSidePaneTrialCountdownHeader')}
            />

            <div className={styles.badgeContainer}>
                <div className={styles.copilotActualIcon}>
                    <CopilotActualIcon />
                </div>
            </div>

            <div style={{ padding: '0px 8px', width: '100%', boxSizing: 'border-box' }}>
                <ProgressBar progress={progress} message={progressMessage} />
            </div>

            <div className={styles.taskList}>
                {actions.map((action) => (
                    <LftTaskCard
                        key={action.id}
                        id={action.id}
                        primaryContent={action.primaryContent}
                        icon={action.icon}
                        onClick={action.onClick}
                    />
                ))}
            </div>

            <div className={styles.adminMessageContainer}>
                <div className={styles.adminMessageText}>
                    {strings.getString('lftSidePaneTrialCountDownAdminText')}
                </div>
            </div>

            <div className={styles.dividerContainer}>
                <div className={styles.dividerLine} />
            </div>

            <div className={styles.exploreLinkContainer}>
                <div className={styles.exploreLinkText}>
                    {strings.getString('lftSidePaneTrialCOuntDownExpiredTitle')}
                </div>
                <div className={styles.exploreLinkIcon}>
                    <InfoIcon />
                </div>
            </div>
        </div>
    );
};
